function DiscountFlag(shelfs: NodeListOf<Element>) {
  shelfs.forEach((shelf) => {
    const card = shelf.querySelector('.shelf-product-card');
    if (!card) return;

    const oldPrice = card.getAttribute('data-track-shelf-oldprice');
    const bestPrice = card.getAttribute('data-track-shelf-price');

    const highlight = shelf.querySelector('.product-HightLight');

    const notHasDiscount = (highlight?.querySelectorAll('.discount') || []).length <= 0;

    if (!notHasDiscount || !oldPrice || !bestPrice) return;

    const discountElement = document.createElement('p');
    discountElement.className = 'flag discount';

    highlight?.appendChild(discountElement);

    const parsedOldPrice = parseFloat(
      oldPrice
        .trim()
        .replace(/[^0-9,]/g, '')
        .replace(',', '.'),
    );
    const parsedNewPrice = parseFloat(
      bestPrice
        .trim()
        .replace(/[^0-9,]/g, '')
        .replace(',', '.'),
    );

    const discount = ((parsedOldPrice - parsedNewPrice) / parsedOldPrice) * 100;

    if (!parsedOldPrice || !parsedNewPrice || !discount) return;
    discountElement.textContent = `${discount.toFixed(0)}% OFF`;
    discountElement.classList.add('show');
    $(discountElement).show();
  });
}

window.aguadecoco = window.aguadecoco || {};

Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, { discountFlag: DiscountFlag }),
});


export default {};


